export default function Footer() {
  return (
    <footer className="bg-teal-600 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-plane-line text-2xl"></i>
              <span className="text-lg font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>USA Travel Guide</span>
            </div>
            <p className="text-sm text-white/80">
              Đồng hành cùng bạn khám phá nước Mỹ với những hướng dẫn chi tiết và kinh nghiệm thực tế.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-sm">Dịch vụ</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Tour du lịch Mỹ</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Tư vấn visa</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Đặt vé máy bay</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Đặt khách sạn</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-sm">Hướng dẫn</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Xin visa Mỹ</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Kinh nghiệm du lịch</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Địa điểm tham quan</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Ẩm thực Mỹ</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-sm">Liên hệ</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>+84 123 456 789</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@usatravelguide.vn</span>
              </li>
              <li className="flex items-center gap-2 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors cursor-pointer">
                  <i className="ri-youtube-line"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/70">
          <p>© 2024 USA Travel Guide. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Chính sách bảo mật</a>
            <span>•</span>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Điều khoản sử dụng</a>
            <span>•</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}